import React from 'react';
import { Typography, Box, Paper } from '@mui/material';
import ServiceRecordCard from './ServiceRecordCard';

const StatusColumn = ({ title, workOrders, allStatuses, onStatusChange, onMarkAsDelivered }) => {
  // Durum başlığına göre renk belirle
  const getStatusColor = (status) => {
    switch (status) {
      case 'Beklemede': return { bg: '#fffbeb', border: '#fcd34d', text: '#92400e' }; // Daha açık sarı
      case 'İşlemde': return { bg: '#eff6ff', border: '#60a5fa', text: '#1e40af' }; // Daha açık mavi
      case 'Tamamlandı': return { bg: '#ecfdf5', border: '#34d399', text: '#065f46' }; // Daha açık yeşil
      case 'Teslime Hazır': return { bg: '#f5f3ff', border: '#a78bfa', text: '#5b21b6' }; // Daha açık mor
      default: return { bg: '#f8fafc', border: '#e2e8f0', text: '#1a1a1a' };
    }
  };
  const colors = getStatusColor(title);

  return (
    <Paper
      elevation={0}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: colors.bg,
        border: `2px solid ${colors.border}`,
        borderRadius: 3, // Biraz daha yuvarlak
        overflow: 'hidden', // Köşelerden taşmayı engelle
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
      }}
    >
      {/* Header - Sabit */}
      <Box sx={{
        p: 2,
        borderBottom: `1px solid ${colors.border}`,
        backgroundColor: 'rgba(255,255,255,0.5)', // Hafif transparanlık
        backdropFilter: 'blur(4px)'
      }}>
        <Typography variant="subtitle1" sx={{
          textAlign: 'center',
          fontWeight: 800,
          color: colors.text,
          fontSize: '1rem',
          letterSpacing: '0.025em'
        }}>
          {title.toUpperCase()} ({workOrders.length})
        </Typography>
      </Box>

      {/* Scrollable Content Area */}
      <Box sx={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        p: 1.5,
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,0.1)',
          borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: 'rgba(0,0,0,0.2)',
        }
      }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {workOrders.map(record => (
            <ServiceRecordCard
              key={record.id}
              serviceRecord={record}
              statuses={allStatuses}
              onStatusChange={onStatusChange}
              onMarkAsDelivered={onMarkAsDelivered}
            />
          ))}
          {workOrders.length === 0 && (
            <Typography variant="body2" sx={{ textAlign: 'center', color: 'text.disabled', mt: 4, fontStyle: 'italic' }}>
              Kayıt yok
            </Typography>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default StatusColumn;